import Vue from 'vue'
import VueRouter from 'vue-router'

const load = (component) => {
  return () => import(`../views/${component}.vue`)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'auth',
    component: load('Signin')
  },
  {
    path: '/privacidad',
    name: 'privacidad',
    component: load('Privacidad')
  },
  {
    path: '/app',
    component: load('Dashboard'),
    children: [
      {
        path: '',
        name: 'main',
        component: load('Matutina'),
        meta: { auth: true }
      },
      {
        path: '/matutina',
        name: 'matutina',
        component: load('Matutina'),
        meta: { auth: true }
      },
      {
        path: '/pensamiento',
        name: 'pensamiento',
        component: load('Pensamiento'),
        meta: { auth: true }
      },
      {
        path: '/programacion',
        name: 'programacion',
        component: load('Programacion'),
        meta: { auth: true }
      },
      {
        path: '/libro',
        name: 'libro',
        component: load('Libro'),
        meta: { auth: true }
      },
      {
        path: '/notificacion',
        name: 'notificacion',
        component: load('Notificacion'),
        meta: { auth: true }
      },
      {
        path: '/sugerencias',
        name: 'sugerencias',
        component: load('Sugerencia'),
        meta: { auth: true }
      },
      {
        path: '/oraciones',
        name: 'oraciones',
        component: load('Oracion'),
        meta: { auth: true }
      },
      {
        path: '/videos',
        name: 'videos',
        component: load('Video'),
        meta: { auth: true }
      },
      {
        path: '/galeria',
        name: 'galeria',
        component: load('Galeria'),
        meta: { auth: true }
      },
      {
        path: '/slides',
        name: 'slides',
        component: load('Slide'),
        meta: { auth: true }
      },
      {
        path: '/mensajes',
        name: 'mensajes',
        component: load('Mensaje'),
        meta: { auth: true }
      },
      {
        path: '/instagram',
        name: 'instagram',
        component: load('Instagram'),
        meta: { auth: true }
      },
      {
        path: '/encuestas',
        name: 'encuestas',
        component: load('Encuesta'),
        meta: { auth: true }
      },
      {
        path: '/encuestas/crear',
        name: 'encuestasCrear',
        component: load('EncuestaCreate'),
        meta: { auth: true }
      },
      {
        path: '/encuestas/:id/resultados',
        name: 'resultados',
        component: load('ResultadoEncuesta'),
        props: true,
        meta: { auth: true }
      },
      {
        path: '/encuestas/:id/graficas',
        name: 'graficas',
        component: load('GraficaEncuesta'),
        props: true,
        meta: { auth: true }
      },
      {
        path: '/hashtags',
        name: 'hashtags',
        component: load('Hashtag'),
        props: true,
        meta: { auth: true }
      }
    ]
  },
  {
    path: '*',
    name: '404',
    component: load('404')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.auth) {
    const token = sessionStorage.getItem('token')
    if (token) {
      next()
    } else {
      next({ name: 'auth' })
    }
  } else {
    next()
  }
})

export default router
